import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxBootstrapModulesModule } from '@app/ngx-bootstrap-modules.module';
import { DirectivesModule } from '@directives/directives.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipesModule } from '@pipes/pipes.module';

import { AuditModalComponent } from './audit-modal/audit-modal.component';
import { ButtonModule } from './button/button.module';
import { AddBtnComponent } from './buttons/add-btn.component';
import { ButtonComponent } from './buttons/button.component';
import { CancelBtnComponent } from './buttons/cancel-btn.component';
import { ClearBtnComponent } from './buttons/clear-btn.component';
import { CloseBtnComponent } from './buttons/close-btn.component';
import { GoBackBtnComponent } from './buttons/go-back-btn.component';
import { SaveBtnComponent } from './buttons/save-btn.component';
import { SearchBtnComponent } from './buttons/search-btn.component';
import { CalendarModule } from './calendar/calendar.module';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { ContentContainerComponent } from './content-container/content-container.component';
import { CreateFormModalComponent } from './create-form-modal/create-form-modal.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DaterangePickerComponent } from './datepicker/daterange-picker.component';
import { DomainErrorComponent } from './domain-error/domain-error.component';
import { ComplexFileUploaderComponent } from './file-uploader/complex/complex-file-uploader.component';
import { FileUploaderComponent } from './file-uploader/simple/file-uploader.component';
import { IconModule } from './icon/icon.module';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { InlineNotificationModule } from './inline-notification/inline-notification.module';
import { KartotekaMenuComponent } from './kartoteka-menu/kartoteka-menu.component';
import { ListFooterComponent } from './list-footer/list-footer.component';
import { MapComponent } from './map/map.component';
import { ModalComponent } from './modal/modal.component';
import { ProgressBarModule } from './n-progress-bar/n-progrerss-bar.module';
import { ProgressSpinnerModule } from './n-progress-spinner/n-progrerss-spinner.module';
import { StepperModule } from './n-stepper/stepper.module';
import { TableModule } from './n-table/table.module';
import { NgBootstrapComponentsModule } from './ng-bootstrap-components.module';
import { NoResultsComponent } from './no-results/no-results.component';
import { NotificationModule } from './notification/notification.module';
import { PageSizeMenuComponent } from './page-size-menu/page-size-menu.component';
import { ParameterizedSearchComponent } from './parameterized-search/parameterized-search.component';
import { PersonSearchModalComponent } from './person-search-modal/person-search-modal.component';
import { ProgressIndicatorComponent } from './progress-indicator/progress-indicator.component';
import { RecordsCounterComponent } from './records-counter/records-counter.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { SelectYearComponent } from './select-year/select-year.component';
import { SelectComponent } from './select/select.component';
import { ServerSideSearchSelectComponent } from './select/server-side-search-select.component';
import { SlideToggleComponent } from './slide-toggle/slide-toggle.component';
import { SortArrowDirectionComponent } from './sort-arrow-direction/sort-arrow-direction.component';
import { SorterComponent } from './sorter/sorter.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TabDropdownComponent } from './tab-dropdown/tab-dropdown.component';
import { TableColumnsManagementComponent } from './table/table-columns-management/table-columns-management.component';
import { TableSettingsComponent } from './table/table-settings.component';
import { TextCounterComponent } from './text-counter/text-counter.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { TreeModule } from './tree/tree.module';
import { LeaveFormModalService } from './unsaved-form-changes-guard/leave-form-modal.service';
import { UnsavedFormChangesGuard } from './unsaved-form-changes-guard/unsaved-form-changes.guard';

const externalModules = [NgBootstrapComponentsModule, NgxBootstrapModulesModule, NgSelectModule];
const components = [
  AddBtnComponent,
  AuditModalComponent,
  DomainErrorComponent,
  ButtonComponent,
  CancelBtnComponent,
  ClearBtnComponent,
  CloseBtnComponent,
  ComplexFileUploaderComponent,
  ConfirmationModalComponent,
  ContentContainerComponent,
  CreateFormModalComponent,
  DatepickerComponent,
  DaterangePickerComponent,
  FileUploaderComponent,
  GoBackBtnComponent,
  ImageCropperComponent,
  KartotekaMenuComponent,
  ListFooterComponent,
  MapComponent,
  ModalComponent,
  NoResultsComponent,
  PageSizeMenuComponent,
  ParameterizedSearchComponent,
  PersonSearchModalComponent,
  ProgressIndicatorComponent,
  RecordsCounterComponent,
  SaveBtnComponent,
  SearchBtnComponent,
  SectionHeaderComponent,
  SelectComponent,
  SelectYearComponent,
  ServerSideSearchSelectComponent,
  SlideToggleComponent,
  SortArrowDirectionComponent,
  SorterComponent,
  SpinnerComponent,
  TabDropdownComponent,
  TableColumnsManagementComponent,
  TableSettingsComponent,
  TextCounterComponent,
  TextEditorComponent,
];

@NgModule({
  declarations: components,
  exports: [
    ButtonModule,
    CalendarModule,
    components,
    externalModules,
    IconModule,
    InlineNotificationModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    NotificationModule,
    StepperModule,
    TableModule,
    TreeModule,
  ],
  imports: [
    ButtonModule,
    CalendarModule,
    CommonModule,
    DirectivesModule,
    PipesModule,
    FormsModule,
    IconModule,
    InlineNotificationModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    NotificationModule,
    StepperModule,
    TableModule,
    TreeModule,
    ReactiveFormsModule,
    ...externalModules,
  ],
  providers: [UnsavedFormChangesGuard, LeaveFormModalService],
})
export class ComponentsModule {}
